import styled from 'styled-components';

import $Link from 'components/Link';
import {commonPalette} from 'styles/palette';
import {borderRadius} from 'styles/vars';

export const FormButton = styled.button.attrs({
  type: 'button'
})`
  background: ${p => p.theme.buttonColor};
  border: 1px solid transparent;
  border-radius: ${p => borderRadius[p.device]};
  color: #fff;
  cursor: pointer;
  display: block;
  font-family: inherit;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.25px;
  line-height: 18px;
  outline: 0;
  padding: 11px 8px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;

  &:focus {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 999;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  ${p =>
    p.isInverse &&
    `
    background: #fff;
    border-color: ${commonPalette.borderGrey};
    color: ${p.theme.buttonColor};
    `}
`;

export const FormButtonLink = FormButton.withComponent($Link);
